// <auto-generated>
// This file is automatically generated from DSL.
// Do not modify this file directly. Changes will be overwritten.
// Source: dsl/setupFlows/*.yaml
// Generated: 2026-11-02T12:14:40.904Z
// </auto-generated>

import { lazy, Suspense } from 'react';

const SetupFlowView = lazy(() => import('@/components/setupFlows/SetupFlowView').then(m => ({ default: m.SetupFlowView })));

/** The Setup Flow hubs (docs/15-designspecs/Setup-Flows.md), each the generic SetupFlowView. */
export const setupFlowRoutes = [
  {
    path: '/finance/setup/budget-setup',
    element: <Suspense><SetupFlowView endpoint="/api/finance/setup-flows/budget-setup/status" /></Suspense>,
  },
  {
    path: '/forestry/setup/pre-calculation-setup',
    element: <Suspense><SetupFlowView endpoint="/api/forestry/setup-flows/pre-calculation-setup/status" /></Suspense>,
  },
];
